import { makeStyles } from 'tss-react/mui';

import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';

interface Props {
  leadCreatedImagePath: string;
}

const useStyles = makeStyles<Props>({ name: 'LeadFormV2Component' })(
  ({ brandType, brandColors, breakpoints, type, typography }, props) => ({
    leadCreatedModal: {
      display: 'flex',
      [breakpoints.up(ScreenSize.MEDIUM)]: {
        height: typography.pxToRem(600),
      },
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        flexDirection: 'column',
        height: typography.pxToRem(1000),
      },
    },
    leadCreatedModalText: {
      flex: 1,
      paddingLeft: typography.pxToRem(50),
      paddingRight: typography.pxToRem(50),
      paddingTop: typography.pxToRem(100),
      color: brandColors.primaryMain,
      '& h1': {
        textWrap: 'pretty',
        fontSize: typography.pxToRem(22),
        fontWeight: 500,
        lineHeight: typography.pxToRem(26.4),
        letterSpacing: typography.pxToRem(-0.48),
        marginBottom: typography.pxToRem(50),
        [breakpoints.up(ScreenSize.SMALL)]: {
          ...brandType['heading-xxs'],
        },
      },
      '& h2': {
        textWrap: 'pretty',
        ...type['18_medium'],
        marginBottom: typography.pxToRem(50),
        [breakpoints.up(ScreenSize.SMALL)]: {
          ...type['24_medium'],
        },
      },
      '& p': {
        ...type['16_medium'],
        marginBottom: typography.pxToRem(50),
        [breakpoints.up(ScreenSize.SMALL)]: {
          ...type['20_medium'],
          marginBottom: 0,
        },
      },
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        paddingTop: typography.pxToRem(10),
        flex: '0 auto',
      },
    },
    leadCreatedImage: {
      backgroundImage: props.leadCreatedImagePath,
      flex: 1,
      backgroundSize: 'cover',
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        flex: '0 auto',
        height: 200,
        width: '100%',
      },
    },
    closeIcon: {
      background: 'none',
      border: 'none',
      position: 'absolute',
      top: typography.pxToRem(8),
      right: typography.pxToRem(10),
      cursor: 'pointer',
      color: brandColors.offWhite,
      '& svg': {
        [breakpoints.up(ScreenSize.MEDIUM)]: {
          right: typography.pxToRem(12),
          width: `${typography.pxToRem(40)} !important`,
          color: 'black',
        },
      },
    },
  })
);

export default useStyles;
